// Author Shi Wen Long
// Date 2021-08-25 12:04:20

class SithMesPrdSdProjectWbsHrc {
constructor({
        id = null,
        wbs = '',
        projectDefinition = '',
        up = '',
        down = '',
        leftSide = '',
        rightSide = '',
        remark = ''}
= {}) {
    this.id = id;
    this.wbs = wbs;
    this.projectDefinition = projectDefinition;
    this.up = up;
    this.down = down;
    this.leftSide = leftSide;
    this.rightSide = rightSide;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdSdProjectWbsHrc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.wbs',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.projectDefinition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'up',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.up',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'down',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.down',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'leftSide',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.leftSide',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rightSide',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.rightSide',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    wbsFilter : "",
    projectDefinitionFilter : "",
    upFilter : "",
    downFilter : "",
    leftSideFilter : "",
    rightSideFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'wbsFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.filter.wbs',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectDefinitionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.filter.projectDefinition',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'upFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.filter.up',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'downFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.filter.down',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'leftSideFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.filter.leftSide',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rightSideFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.filter.rightSide',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.projectDefinition',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'up',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.up',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'down',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.down',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'leftSide',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.leftSide',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rightSide',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.rightSide',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectWbsHrc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdSdProjectWbsHrc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
